import styled from "styled-components";
import {media} from "../../../theme/responsive";
import {CharcoalBlack, DarkSlate, Teal} from "../../../theme/variable";

export const UploadFileBox = styled.div`
    color: ${DarkSlate};
    visibility: ${(props) => (props.isEdit ? "hidden" : "")};
    height: ${(props) => (props.isEdit ? "0" : "")};
    text-align: ${(props) => (props.rgtAlignFileBox ? "right" : "")};
    input[type="file"] {
        display: none;
    }
    span {
        display: ${(props) => (props.rgtAlignFileBox ? "block" : "none")};
        float: left;
        color: #8c929b;
        font-size: 0.625rem;
        ${media.laptop`font-size: 0.75rem;`}
    }
    label {
        border: 1px solid ${Teal};
        display: ${(props) => (props.hideUploadFileBox ? "none" : "inline-block")};
        width: 98px;
        height: 24px;
        line-height: 24px;
        cursor: pointer;
        color: ${Teal};
        text-align: center;
        border-radius: 4px;
        font-weight: 400;
        vertical-align: middle;
        font-size: 0.75rem;
        &:hover {
            background: #f0f6ff;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }
        ${media.laptop`width:127px;`}
    }
`;
export const UploadFileText = styled.div`
    display: ${(props) => (props.hideUploadDisclaimer ? "none" : "inline-block")};
    margin-left: ${(props) => (props.notRequiredStyle ? "0" : "12px")};
    vertical-align: middle;
    width: ${(props) => (props.notRequiredStyle ? "100%" : "66%")};
    p {
        font-size: 0.75rem;
        color: ${DarkSlate};
        line-height: 18px;
    }
    span {
        color: ${CharcoalBlack};
    }
    ${media.laptop` margin-left: ${(props) => (props.notRequiredStyle ? "0" : "16px")};width:72%;`}
`;
